import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Route, Routes, Link } from 'react-router-dom';
import Router from './routes';
import { ThemeProvider } from './theme'

function App() {
  return (
    <ThemeProvider>
    <Router />
  </ThemeProvider>
  );
}

export default App;
                 